import { render, staticRenderFns } from "./videolist_2.vue?vue&type=template&id=55fe89da&scoped=true&"
import script from "./videolist_2.vue?vue&type=script&lang=js&"
export * from "./videolist_2.vue?vue&type=script&lang=js&"
import style0 from "./videolist_2.vue?vue&type=style&index=0&id=55fe89da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fe89da",
  null
  
)

export default component.exports